import { Color } from '@mui/material';
import { primary } from './primary';

export const neutral: Partial<Color> = {
  ...primary,
};
